// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__YFicy","tab":"Tabs_tab__2rt5r","tabActive":"Tabs_tabActive__1KkK9"};